<template>
  <div class="login-form">
    <p class="login-form__title">
      Войти
    </p>
    <p class="login-form__text">
      Email
    </p>
    <pInput
        :value="loginFormData.email"
        :placeholder="'Введите вашу почту'"
        @input="setEmail"
    />
    <p class="login-form__text">
      Пароль
    </p>
    <pInput
        :value="loginFormData.password"
        :placeholder="'Придумайте пароль'"
        type="password"
        @input="setPassword"
    />
    <pButton class="login-form__login" @click="sendRequest">
      Войти
    </pButton>
    <button class="login-form__recovery" @click="authPopupStore.openRecoveryForm">
      Забыли пароль
    </button>
    <span class="login-form__help">
      У вас нет учетной записи?
      <span
        class="login-form__sign"
        @click="authPopupStore.openLoginForm"
      >
        Регистрация
      </span>
    </span>
  </div>
</template>

<script setup lang="ts">
import pInput from '../../common/pInput/pInput.vue'
import pButton from '../../common/pButton/pButton.vue'
import { Ref, ref } from 'vue'
import { useAuthPopup } from './../store/authPopup'
import LoginFormData from "@/authSection/types/LoginFormData";
import api from "../api/api";
import { AxiosError } from "axios";
import { useClientStore } from "@/authSection/store/clientStore";

const authPopupStore = useAuthPopup()
const clientStore = useClientStore()
const loginFormData: Ref<LoginFormData> = ref({
  email: '',
  password: '',
})

function setEmail(event: Event) {
  loginFormData.value.email = (event.target as HTMLInputElement).value
}

function setPassword(event: Event) {
  loginFormData.value.password = (event.target as HTMLInputElement).value
}

async function sendRequest() {
  try {
    await api.loginClient(loginFormData.value)
    authPopupStore.visible = false
    clientStore.isAuth = true
  } catch (e: unknown) {
    if (e instanceof AxiosError) {
      if (e.response?.status === 404) {
        window.showNotification('Неверный логин или пароль!', 'warning')
      }
    } else {
      window.showNotification('Произошла ошибка!', 'error')
    }
  }
}
</script>

<style scoped lang="scss">
$color-yellow: #FFED48;

.login-form {
  padding: 23px 16px;
  display: flex;
  flex-direction: column;
  background: #090A0C;
  border-radius: 12px;
  font-family: "Inter", sans-serif;

  &__title {
    text-align: center;
    font-weight: 700;
    font-size: 16px;
    line-height: 18px;
    margin-bottom: 20px;
  }

  &__text {
    font-weight: 700;
    font-size: 14px;
    line-height: 16px;
    margin: 15px 0 7px;
  }

  &__login {
    margin-top: 12px;
    font-weight: 600;
    padding: 12px 0;
  }

  &__recovery {
    margin: 12px 0;
    background: transparent;
    cursor: pointer;
    font-weight: 600;
    font-size: 14px;
    line-height: 16px;
    border: none;
    color: #fff;

    @media (hover: hover) {
      &:hover {
        transition: color 0.3s;
        color: $color-yellow;
      }
    }
  }

  &__help {
    color: #737880;
    font-weight: 600;
    font-size: 14px;
    line-height: 16px;
    text-align: center;
  }

  &__sign {
    color: #fff;
    cursor: pointer;

    @media (hover: hover) {
      &:hover {
        transition: color 0.3s;
        color: $color-yellow;
      }
    }
  }
}
</style>